// Bildqualität direkt im Browser, damit der Kunde sofort neu fotografieren
// kann (nicht erst nach dem Absenden). Reine Rechenfunktionen ohne DOM,
// dadurch mit node:test prüfbar.
//
// Schärfe: Varianz des Laplace-Filters auf dem Graubild. Unscharfe Bilder
// haben kaum Kanten → kleine Varianz. Der Wert hängt von der Auflösung ab;
// die Schwelle BLUR_MIN (shared/pruefung.ts) gilt für ~800 px.

export function grayscale(rgba: Uint8ClampedArray, width: number, height: number): Float32Array {
  const gray = new Float32Array(width * height);
  for (let i = 0, j = 0; j < gray.length; i += 4, j++) {
    gray[j] = 0.299 * rgba[i]! + 0.587 * rgba[i + 1]! + 0.114 * rgba[i + 2]!;
  }
  return gray;
}

export function meanBrightness(gray: Float32Array): number {
  let sum = 0;
  for (let i = 0; i < gray.length; i++) sum += gray[i]!;
  return gray.length ? sum / gray.length : 0;
}

export function laplacianVariance(gray: Float32Array, width: number, height: number): number {
  if (width < 3 || height < 3) return 0;
  let sum = 0;
  let sumSq = 0;
  let n = 0;
  for (let y = 1; y < height - 1; y++) {
    const row = y * width;
    for (let x = 1; x < width - 1; x++) {
      const i = row + x;
      const v = gray[i - width]! + gray[i + width]! + gray[i - 1]! + gray[i + 1]! - 4 * gray[i]!;
      sum += v;
      sumSq += v * v;
      n++;
    }
  }
  const mean = sum / n;
  return sumSq / n - mean * mean;
}

export function analyzePixels(rgba: Uint8ClampedArray, width: number, height: number) {
  const gray = grayscale(rgba, width, height);
  return {
    brightness: Math.round(meanBrightness(gray) * 10) / 10,
    blurScore: Math.round(laplacianVariance(gray, width, height) * 10) / 10,
  };
}

/** Zielgröße: längste Kante ~800 px (Vorgabe), nie vergrößern. */
export function targetSize(width: number, height: number, maxEdge = 800): { width: number; height: number } {
  const scale = Math.min(1, maxEdge / Math.max(width, height));
  return { width: Math.round(width * scale), height: Math.round(height * scale) };
}
